import { render, staticRenderFns } from "./intermediariesModel.vue?vue&type=template&id=90a60792&scoped=true"
import script from "./intermediariesModel.vue?vue&type=script&lang=js"
export * from "./intermediariesModel.vue?vue&type=script&lang=js"
import style0 from "./intermediariesModel.vue?vue&type=style&index=0&id=90a60792&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a60792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a60792')) {
      api.createRecord('90a60792', component.options)
    } else {
      api.reload('90a60792', component.options)
    }
    module.hot.accept("./intermediariesModel.vue?vue&type=template&id=90a60792&scoped=true", function () {
      api.rerender('90a60792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/intermediariesModel.vue"
export default component.exports